/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProvider
 */
export interface UserProvider {
    /**
     * 
     * @type {string}
     * @memberof UserProvider
     */
    provider: UserProviderProviderEnum;
}


/**
 * @export
 */
export const UserProviderProviderEnum = {
    Google: 'google'
} as const;
export type UserProviderProviderEnum = typeof UserProviderProviderEnum[keyof typeof UserProviderProviderEnum];


/**
 * Check if a given object implements the UserProvider interface.
 */
export function instanceOfUserProvider(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "provider" in value;

    return isInstance;
}

export function UserProviderFromJSON(json: any): UserProvider {
    return UserProviderFromJSONTyped(json, false);
}

export function UserProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProvider {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': json['provider'],
    };
}

export function UserProviderToJSON(value?: UserProvider | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': value.provider,
    };
}

